import { oc } from '@orpc/contract';
import { listProtocolsInputSchema, listProtocolsOutputSchema } from '../schemas/protocols.schemas.js';
export const listProtocolsContract = oc
    .route({
    method: 'GET',
    path: '/protocols',
    tags: ['Protocols'],
    summary: 'List measurement protocols and their versions',
})
    .input(listProtocolsInputSchema)
    .output(listProtocolsOutputSchema);
//# sourceMappingURL=list-protocols.contract.js.map